import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormModule } from '@woolworthsnz/form';
import { StyleguideModule } from '@woolworthsnz/styleguide';
import { FilterDisclaimerComponent } from './filter-disclaimer/filter-disclaimer.component';
import { FilterGroupComponent } from './filter-group/filter-group.component';
import { FilterTagsComponent } from './filter-tags/filter-tags.component';
import { LegacySearchHeaderComponent } from './legacy-search-header/legacy-search-header.component';
import { NoResultsComponent } from './no-results/no-results.component';
import { PiesSearchHeaderComponent } from './pies-search-header/pies-search-header.component';
import { SearchFooterComponent } from './search-footer/search-footer.component';
import { SearchHeaderComponent } from './search-header/search-header.component';
import { SearchPaginationComponent } from './search-pagination/search-pagination.component';
import { SearchResultsHeaderComponent } from './search-results-header/search-results-header.component';
import { SearchDasFilterComponent } from './search-das-filter/search-das-filter.component';
import { SearchCategoryListComponent } from './search-category-list/search-category-list.component';
import { SearchErrorComponent } from './search-error/search-error.component';

@NgModule({
	imports: [
		CommonModule,
		FormModule,
		StyleguideModule,
		ReactiveFormsModule,
		RouterModule,
		SearchHeaderComponent,
		PiesSearchHeaderComponent,
		LegacySearchHeaderComponent,
		FilterGroupComponent,
		FilterDisclaimerComponent,
		FilterTagsComponent,
		SearchPaginationComponent,
		SearchFooterComponent,
		NoResultsComponent,
		SearchResultsHeaderComponent,
		SearchDasFilterComponent,
		SearchCategoryListComponent,
		SearchErrorComponent,
	],
	exports: [
		SearchHeaderComponent,
		PiesSearchHeaderComponent,
		LegacySearchHeaderComponent,
		FilterGroupComponent,
		FilterDisclaimerComponent,
		FilterTagsComponent,
		SearchPaginationComponent,
		SearchFooterComponent,
		NoResultsComponent,
		SearchResultsHeaderComponent,
		SearchDasFilterComponent,
		SearchCategoryListComponent,
		SearchErrorComponent,
	],
})
export class SearchLibModule {}
